import { useSelector } from 'react-redux';
import { getAllFilters } from 'redux/slices/icalendarFilterSlice';
import { fetchUnitsAction } from 'redux/slices/unitSlice';
import CustomSelectWithInfiniteScroll from '../../../common/components/CustomSelectWithInfiniteScroll';

const SelectAssets = (props) => {
    // If this component is used in the calendar filter context, use Redux state
    const filters = useSelector(getAllFilters);

    // Use props.id if provided (for other contexts) or get it from Redux state
    const assetId = props.id || filters.asset || 'all';

    return (
        <CustomSelectWithInfiniteScroll
            {...props}
            id={assetId}
            type="asset"
            selectAll={true}
            fetchAction={fetchUnitsAction}
            label={(item) => (
                <>
                    {item.productName} ( {item.externalId || item.id} )
                </>
            )}
            i18nKeys={{
                searchPlaceholder: 'iCalendar.filter.searchAssets',
                allItems: 'iCalendar.filter.allAssets',
            }}
        />
    );
};

export default SelectAssets;
